// extracted by mini-css-extract-plugin
export default {"LocationSelection":"LocationSelection-module-fc502d2706cfd23818bf"};